import Hiloading from './loading.vue'

const HiLoading = {
    install(Vue) {
        if (typeof window !== 'undefined' && window.Vue) {
            Vue = window.Vue
        }
        let tpl;
        // 挂载到vue原型上，暴露两个方法
        Vue.prototype.$hiloading = {
            show(){
                var loading = Vue.extend(Hiloading);
                tpl = new loading().$mount().$el;
                // debugger
                document.body.appendChild(tpl);
                return tpl
            },
            hide(){
                return document.body.removeChild(tpl);
            }
 
        }
    }

}

// const HLoading = {
//   install: function(Vue) {
//     Vue.component(Hloading.name, Hloading)
//   }
// }
// if (typeof window !== 'undefined' && window.Vue) { 
//     window.Vue.use(HLoading) 
// }


export default HiLoading


// WEBPACK FOOTER //
// ./src/components/loading/index.js